import { extractErrorInfo } from './errorInfo';

export const API_KEY_MANAGEMENT_PERMISSION_MESSAGE =
  'Your publisher role does not include team management. Ask a publisher owner or someone with team-management access to manage API keys.';
const TEAM_MANAGEMENT_PERMISSION_MESSAGE =
  'Your publisher role does not include team management. Ask a publisher owner or someone with team-management access to manage team access.';

function canManagePublisherTeam(canManageTeam?: boolean | null): boolean {
  return canManageTeam === true;
}

export function canAccessApiKeyManagement(
  canManageTeam?: boolean | null,
): boolean {
  return canManagePublisherTeam(canManageTeam);
}

export function getApiKeyManagementPermissionMessage(
  canManageTeam?: boolean | null,
): string | undefined {
  return canAccessApiKeyManagement(canManageTeam)
    ? undefined
    : API_KEY_MANAGEMENT_PERMISSION_MESSAGE;
}

export function getTeamManagementPermissionMessage(
  canManageTeam?: boolean | null,
): string | undefined {
  return canManagePublisherTeam(canManageTeam)
    ? undefined
    : TEAM_MANAGEMENT_PERMISSION_MESSAGE;
}

export function isManageTeamPermissionError(error: unknown): boolean {
  return extractErrorInfo(error).searchText.includes(
    'you do not have the manageteam permission',
  );
}
